var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.modal
    ? _c(
        "div",
        {
          staticClass: "disabled-info",
          class: { contactum_backdrop: _vm.visibility }
        },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.isVisible,
                "before-close": _vm.close,
                width: _vm.modal.video || _vm.modal.image ? "74%" : "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isVisible = $event
                }
              }
            },
            [
              _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                _c("h4", [_vm._v(_vm._s(!_vm.modal ? "Field disabled" : ""))])
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "items-center", attrs: { gutter: 25 } },
                [
                  _vm.modal.video || _vm.modal.image
                    ? _c("el-col", { attrs: { span: 12 } }, [
                        _vm.modal.video
                          ? _c("div", { staticClass: "video-wrapper mr-3" }, [
                              _c("iframe", {
                                staticStyle: {
                                  width: "100%",
                                  height: "300px",
                                  "border-radius": "10px"
                                },
                                attrs: {
                                  src: _vm.modal.video,
                                  title: "Video preview",
                                  frameborder: "0",
                                  allow:
                                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                  allowfullscreen: ""
                                }
                              })
                            ])
                          : _c("div", { staticClass: "mr-3" }, [
                              _c("img", {
                                staticClass: "w-100 img-thumb",
                                attrs: {
                                  src: _vm.modal.image,
                                  alt: _vm.modal.title
                                }
                              })
                            ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      attrs: {
                        span: _vm.modal.video || _vm.modal.image ? 12 : 24
                      }
                    },
                    [
                      _c("div", { staticClass: "video-content text-center" }, [
                        !_vm.modal.video && !_vm.modal.image
                          ? _c("div", { staticClass: "placeholder-icon" }, [
                              _c("i", { staticClass: "el-icon-video-camera" })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("h3", { staticClass: "mb-3 title" }, [
                          _vm._v(_vm._s(_vm.modal.title))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "text" }, [
                          _vm._v(_vm._s(_vm.modal.description))
                        ]),
                        _vm._v(" "),
                        !_vm.modal.hidePro
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "el-button mt-2 el-button--primary",
                                attrs: {
                                  target: "_blank",
                                  href: _vm.campaignUrl
                                }
                              },
                              [_vm._v("Upgrade to PRO")]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }